import { $, CustomEventWithDetail, html, View } from 'rune-ts';
import { CategoryLevel1_CODE, ICategory } from '../../../../../../shared/mps-shared/domain/category/types.ts';
import klass from './ProductListCateItemView.module.scss';
import { createGoodsUrlBuilder } from '@services/MarppleShop/features/ProductList/util';
import { font } from '@services/MarppleShop/shared/typography';
import { MpsCategory } from '../../../../../../shared/mps-shared/domain/category/accessor.ts';
import { CategoryServiceS } from '../../../../../../shared/mps-shared/service/category-share.service.ts';
export type ProductListCateItemData = {
  is_mobile: boolean;
  without_sold_out?: boolean;
  readonly cate_root: ICategory;
  selected_cate_list: ICategory;
  selected_cate_item?: ICategory;
};

export class ProductListCateItemEvent extends CustomEventWithDetail<{
  cate_root_id: number;
  cate_list_id: number;
  cate_item_id: number | null;
  originalEvent: MouseEvent;
}> {}

export class ProductListCateItemView extends View<ProductListCateItemData> {
  private selectedCateList = CategoryServiceS.createMpsCategoryAccessor(this.data.selected_cate_list);
  private selectedCateItem = this.data.selected_cate_item
    ? CategoryServiceS.createMpsCategoryAccessor(this.data.selected_cate_item)
    : null;

  private _makeFont(is_selected: boolean) {
    if (is_selected) {
      if (this.data.is_mobile) {
        return font('14_bold');
      } else {
        return font('16_bold');
      }
    } else {
      if (this.data.is_mobile) {
        return font('14_medium');
      } else {
        return font('16_medium');
      }
    }
  }

  protected override template() {
    if (this.data.cate_root.code === CategoryLevel1_CODE.GOODS) {
      const is_selected = !this.selectedCateItem;
      const cate_list_id = this.selectedCateList.getId();
      return html` <div class="${klass.cate_items}">
        <a
          href="${createGoodsUrlBuilder()
            .setPage('PRODUCTS')
            .setFilters({
              cate_list_id: this.selectedCateList.getId(),
              without_sold_out: this.data.without_sold_out,
            })
            .build()}"
          class="${klass.cate_item} ${this._makeFont(is_selected)} ${is_selected ? klass.selected : ''}"
          data-cate_list_id="${cate_list_id}"
          data-cate_item_id=""
        >
          ${ET('mps2::product::all')}
        </a>
        ${this.selectedCateList.getChildren().map((cate_item) => {
          const is_selected = this.selectedCateItem?.getCode() == cate_item.getCode();
          const cate_item_id = cate_item.getId();
          return html`
            <a
              href="${createGoodsUrlBuilder()
                .setPage('PRODUCTS')
                .setFilters({
                  cate_list_id: this.selectedCateList.getId(),
                  cate_item_id: cate_item.getId(),
                  without_sold_out: this.data.without_sold_out,
                })
                .build()}"
              class="${klass.cate_item} ${this._makeFont(is_selected)} ${is_selected ? klass.selected : ''}"
              data-cate_list_id="${cate_list_id}"
              data-cate_item_id="${cate_item_id}"
            >
              ${cate_item.getName()}
            </a>
          `;
        })}
      </div>`;
    }
    return html`<div style="display: none"></div>`;
  }

  public setSelectedCateList(selected_cate_list: MpsCategory) {
    this.selectedCateList = selected_cate_list;
    this.selectedCateItem = null;
    return this;
  }

  protected override onRender() {
    if (this.data.is_mobile) {
      const selected$ = $(this.element()).find(`.${klass.selected}`)?.element();
      if (selected$) {
        this.element().scrollLeft = selected$.offsetLeft - 16;
      }
    }

    this.delegate('click', `[data-cate_list_id]`, (e) => {
      const cate_item$ = e.currentTarget as HTMLElement;
      const selected_item$ = $(this.element()).find(`.${klass.selected}[data-cate_list_id]`);
      if (selected_item$) {
        selected_item$.removeClass(klass.selected);
        selected_item$.removeClass(this._makeFont(true));
        selected_item$.addClass(this._makeFont(false));
      }
      $(cate_item$).addClass(klass.selected);
      $(cate_item$).addClass(this._makeFont(true));
      this.dispatchEvent(ProductListCateItemEvent, {
        bubbles: true,
        detail: {
          cate_root_id: Number(cate_item$.dataset.cate_root_id),
          cate_list_id: Number(cate_item$.dataset.cate_list_id),
          cate_item_id: Number(cate_item$.dataset.cate_item_id) || null,
          originalEvent: e.originalEvent,
          view: this,
        },
      });
    });
  }
}
